import $ from 'jquery';

import 'slick-slider';

$(document).ready(() => {
	const $slider = $('.video-slider__wrapper');

	$slider.on('beforeChange', (event, slick, currentSlide) => {
		slick.$slides[currentSlide].querySelector('video').pause();
		slick.$slides[currentSlide].querySelector('.video-slider__slide').classList.remove('video-slider__slide--playing');
	});
	$slider.slick({
		arrows: true,
		slidesToShow: 1,
		centerMode: true,
		centerPadding: '25%',
	});

	$('.video-slider__play').on('click', (event) => {
		event.preventDefault();
		const $slide = $(event.currentTarget).closest('.video-slider__slide');
		$slide.find('video')[0].play();
		$slide.addClass('video-slider__slide--playing');
	});

	$('.video-slider__slide video').on('ended', (event) => {
		$(event.currentTarget).closest('.video-slider__slide').removeClass('video-slider__slide--playing');
	});
});
